import type { LogLevel, Environment } from "../types";

export const LOG_LEVELS: Record<LogLevel, number> = {
	debug: 0,
	info: 1,
	warn: 2,
	error: 3,
};

export function shouldLog(
	currentLevel: LogLevel,
	minimumLevel: LogLevel,
): boolean {
	return LOG_LEVELS[currentLevel] >= LOG_LEVELS[minimumLevel];
}

export function isValidLogLevel(level: string): level is LogLevel {
	return level in LOG_LEVELS;
}

export function shouldLogInEnvironment(
	level: LogLevel,
	environment: Environment = "development",
): boolean {
	if (environment === "production") {
		return level === "error" || level === "warn";
	}

	if (environment === "test") {
		return level === "error";
	}

	return true;
}
